function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
var useTile = function useTile(context, _ref) {
  var variant = _ref.variant;
  var _React$useContext = React.useContext(context),
    _React$useContext$chi = _React$useContext.childIndexes,
    childIndexes = _React$useContext$chi === void 0 ? [] : _React$useContext$chi,
    _React$useContext$set = _React$useContext.setChildIndexes,
    setChildIndexes = _React$useContext$set === void 0 ? function () {} : _React$useContext$set,
    _React$useContext$til = _React$useContext.tileSize,
    tileSize = _React$useContext$til === void 0 ? {} : _React$useContext$til,
    contextVariant = _React$useContext.variant;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLastChild = _React$useState2[0],
    setIsLastChild = _React$useState2[1];
  var elementRef = React.useRef();
  var onRefSet = React.useCallback(function (node) {
    if (node && !childIndexes.includes(node)) {
      setChildIndexes(function (prevChildIndexes) {
        return [].concat(_toConsumableArray(prevChildIndexes), [node]).sort(function (a, b) {
          return (
            // eslint-disable-next-line sonarjs/bitwise-operators
            a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
          );
        });
      });
      elementRef.current = node;
    }
  }, [childIndexes]);
  React.useEffect(function () {
    return function () {
      setChildIndexes(childIndexes.filter(function (node) {
        return node !== elementRef.current;
      }));
    };
  }, []);
  React.useEffect(function () {
    setIsLastChild(childIndexes.indexOf(elementRef.current) === childIndexes.length - 1);
  }, [childIndexes]);
  return {
    isLastChild: isLastChild,
    onRefSet: onRefSet,
    tileSize: tileSize,
    variant: variant !== 'default' ? variant : contextVariant
  };
};
export default useTile;